import {Injectable} from '@angular/core';
import * as L from 'leaflet';

@Injectable({
  providedIn: 'root'
})
export class GeoAssetsService {
  constructor() {

  }

  accessToken: string = 'pk.eyJ1IjoiYXJpZ2FuaXMiLCJhIjoiY2s4c2l3bmF3MGdoMjNvcDl0Y3FzaDN5ZiJ9.AiX7yHmyGI_bFoWjWxHq7g';

  styleDE: string = 'ariganis/ck8sjdvd5281d1iqltb4fhepb';
  styleEN: string = 'ariganis/ck8sl8xym035r1imhxxbu8p5b';
  styleMon: string = 'ariganis/ckdewomxk5hs61hl6z31aqnyh/draft';
  styleDark: string = 'ariganis/ckt1cnxxl0wbl17o1356wlky3/draft';

  pin = L.icon({
    iconSize: [25, 41],
    iconAnchor: [13, 41],
    iconUrl: '/assets/marker-icon.png'
  });

  circlepin = L.icon({
    iconSize: [25, 25],
    iconAnchor: [13, 13],
    iconUrl: 'assets/circle-icon.png'
  });

  emptyPin = L.icon({
    iconSize: [25, 25],
    iconAnchor: [13, 13],
    iconUrl: ''
  });

  circleXL = L.icon({
    iconSize: [91, 91],
    iconAnchor: [46, 46],
    iconUrl: 'assets/map/markers/circle-xl.png'
  });

  circleL = L.icon({
    iconSize: [75, 75],
    iconAnchor: [38, 38],
    iconUrl: 'assets/map/markers/circle-l.png'
  });

  circleM = L.icon({
    iconSize: [51, 51],
    iconAnchor: [26, 26],
    iconUrl: 'assets/map/markers/circle-m.png'
  });

  circleS = L.icon({
    iconSize: [39, 39],
    iconAnchor: [20, 20],
    iconUrl: 'assets/map/markers/circle-s.png'
  });

  circleXS = L.icon({
    iconSize: [31, 31],
    iconAnchor: [16, 16],
    iconUrl: 'assets/map/markers/circle-xs.png'
  });

  getMap(lang?: string, theme?: string) {
    let selectedTheme = this.styleMon;
    if (theme === 'dark-theme') {
      selectedTheme = this.styleDark;
    }
    if (lang) {
      switch (lang.toLowerCase()) {
        case 'de':
          return 'https://api.mapbox.com/styles/v1/' + selectedTheme + '/tiles/256/{z}/{x}/{y}?access_token=' + this.accessToken;
      }
    }
    return 'https://api.mapbox.com/styles/v1/' + selectedTheme + '/tiles/256/{z}/{x}/{y}?access_token=' + this.accessToken;
  }

  getCircleIconBySize(size: number): L.Icon {
    if (size >= 10000) {
      return this.circleXL;
    }
    if (size >= 1000) {
      return this.circleL;
    }
    if (size >= 100) {
      return this.circleM;
    }
    if (size >= 10) {
      return this.circleS;
    }
    return this.circleXS;
  }

  getCircleClassBySize(size: number): string {
    if (size >= 10000) {
      return 'leaflet-circle-xl';
    }
    if (size >= 1000) {
      return 'leaflet-circle-l';
    }
    if (size >= 100) {
      return 'leaflet-circle-m';
    }
    if (size >= 10) {
      return 'leaflet-circle-s';
    }
    return 'leaflet-circle-xs';
  }

}
